import React, {useEffect, useState} from 'react'
import {InvisibleContainer} from '../../../Components/Layout/Grid'
import {useTranslation} from 'react-i18next'
import {useNavigation} from 'react-navi'
import {Title} from '../../../sharedComponents/components'
import {FormSubmitButton} from '../../../Components/Atoms/Buttons'
import {colors} from '../../../sharedComponents/colors'
import * as AmplifyAuth from 'aws-amplify/auth'
import authApi from '../../../state/auth'
import {useAppState} from '../../../state'
import {Amplify} from 'aws-amplify'

const SsoLogin = () => {
  console.log('SsoLogin render', window.location.href)
  const navi = useNavigation()
  const {actions, state} = useAppState()
  const {t} = useTranslation('auth')
  const [error, setError] = useState<string | null>(null)
  const [ssoCheckDone, setSsoCheckDone] = useState(false)

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search)
      const err = params.get('error')
      const desc = params.get('error_description')

      if (err) {
        throw new Error(`${err}: ${desc}`)
      }

      let idToken: any | undefined

      for (let i = 0; i < 20; i++) {
        await authApi.getCurrentUser()
        const session = await authApi.getTokens()

        if (session?.idToken) {
          idToken = session.idToken
          break
        }

        await new Promise(resolve => setTimeout(resolve, 250))
      }

      if (!idToken) {
        throw new Error('SSO login failed: No id token found after redirect')
      }

      const typedEmail = sessionStorage.getItem('ssoLoginEmail')?.toLowerCase()
      const payload = idToken.payload as any
      const emailFromToken = payload?.email?.toLowerCase()

      if (typedEmail && emailFromToken && typedEmail !== emailFromToken) {
        await actions.logout()
        sessionStorage.removeItem('ssoLoginEmail')
        window.location.href = '/login?error=sso_email_mismatch'
        return
      }

      sessionStorage.removeItem('ssoLoginEmail')
      setSsoCheckDone(true)
    }

    run().catch(err => {
      console.error('SSO login error:', err)
      setError(err?.message ?? 'SSO failed')
    })
  }, [])

  useEffect(() => {
    if (!ssoCheckDone) return
    if (state.appStateMachine.current !== 'READY') return

    const postLoginRedirect = sessionStorage.getItem('postLoginRedirect')
    if (postLoginRedirect) {
      sessionStorage.removeItem('postLoginRedirect')
      window.location.href = postLoginRedirect
    } else {
      navi.navigate('/')
    }
  }, [ssoCheckDone, state.appStateMachine])

  if (error)
    return (
      <InvisibleContainer>
        <Title level={2}>{t('auth:sso.loginFailed', 'SSO Login Failed')}</Title>
        <p style={{color: colors.system.white}}>{error}</p>
        <FormSubmitButton type="button" onClick={() => navi.navigate('/login')}>
          {t('common:back', 'Back')}
        </FormSubmitButton>
      </InvisibleContainer>
    )
  return <div style={{padding: 24}}>Signing you in…</div>
}

export default SsoLogin
